












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ActividadesDetalleGrid from '@/pantallas/Inicio/DetalleVehiculo/ActividadesDetalleGrid.vue';
import AlertasDetalleGrid from '@/pantallas/Inicio/DetalleVehiculo/AlertasDetalleGrid.vue';
import ComunicacionesGrid from '@/pantallas/Inicio/DetalleVehiculo/ComunicacionesGrid.vue';
import vehiculoEventBus from '../VehiculosGrid/vehiculoEventBus';
import { Vehiculo } from '../VehiculosData/fetchVehiculos';
import { Actividad } from '../ActividadesData/fetchActividades';
import store from '../../../store';
import {
  PermisoAccion,
  CodigoAccion,
} from '../../../views/base/VariablesPermisos';
import { ComponenteBase } from '../../../views/base/ComponenteBase';
import { Funcionalidades } from '../../../config/funcionalidades';
import PreventivasDetalleGrid from '@/pantallas/Inicio/DetalleVehiculo/PreventivasDetalleGrid.vue';
import CorrectivasDetalleGrid from '@/pantallas/Inicio/DetalleVehiculo/CorrectivasDetalleGrid.vue';

@Component({
  components: {
    ActividadesDetalleGrid,
    AlertasDetalleGrid,
    ComunicacionesGrid,
    PreventivasDetalleGrid,
    CorrectivasDetalleGrid,
  },
})
export default class DetalleTabs extends ComponenteBase {
  @Prop({ default: false }) verDetalleActivo: boolean;
  funcionalidad: Funcionalidades = Funcionalidades.Inicio;
  mostrarAlertas = false;
  mostrarMantenimiento = false;
  mostrarCorrectivas = false;
  mostrarPreventivas = false;
  tabModel: string = 'tab-1';
  tabKey: number = 1;

  accionComunicaciones: PermisoAccion = {
    accionCodigo: CodigoAccion.Comunicaciones,
    visible: false,
  };
  accionesTotales: PermisoAccion[] = [this.accionComunicaciones];
  mounted() {
    vehiculoEventBus.onAbrirDetalleVehiculo(this.handleAbrirDetalle);
    this.permisosAlertasEIgnicion();
    this.permisosHistoricos();
    this.tabModel = 'tab-1';
  }

  @Watch('verDetalleActivo', { deep: true, immediate: true })
  handleTabModel() {
    this.tabKey++;
  }

  permisosAlertasEIgnicion() {
    if (store.state.permisoAlerta) {
      this.mostrarAlertas = true;
    } else {
      this.mostrarAlertas = false;
    }
  }

  permisosHistoricos() {
    if (store.state.permisoHistorico) {
      this.mostrarMantenimiento = true;
    } else {
      this.mostrarMantenimiento = false;
    }
  }

  handleAbrirDetalle(
    vehiculo: Vehiculo,
    actividad: Actividad,
    ultimaActividad: Actividad,
    show: boolean,
    indice: string
  ) {
    switch (indice) {
      case '0':
        this.tabModel = 'tab-6'; //Llamada para solucionar bug visual de componente v-tab de vuetify.
        setTimeout(() => {
          this.tabModel = 'tab-1';
        }, 100);
        break;
      case '1':
        this.tabModel = 'tab-2';
        break;
      case '2':
        this.tabModel = 'tab-3';
        break;
      default:
        this.tabModel = 'tab-1';
        break;
    }
  }


  get valideSubDomain(): boolean {
    let url: string = window.location.href;
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

    // Si se encontró un subdominio, lo retornamos
    if (subdominio && subdominio.length > 1) {
      switch (
        subdominio[1]
          .split(':')[0]
          .toString()
          .toLowerCase()
      ) {
        case 'gpstrack':
          return true;
        case 'track3':
          return true;
        case 'track3s3':
          return true;
        case 'qagpstrack':
          return true;
          case 'localhost':
          return true;
        default:
          return false;
      }
    } else {
      return true; // No se encontró un subdominio
    }
  }
}
